import React, { useState, useEffect } from "react";
import {
  Button,
  TableRow,
  Table,
  TableHead,
  TableBody,
  TableCell, TableContainer,
  Paper,
  FormControl,
  MenuItem,
  Select,
  Card,
  Box,
  Typography,
  Avatar,
  Chip,
  Collapse,
  InputAdornment,
  TextField,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import ProgressKeyButtons from "../../components/ProgressKeyButtons/ProgressKeyButtons";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FilterPanel, { FilterSection } from '../../components/ui/FilterPanel';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import FilterListIcon from '@material-ui/icons/FilterList';
import CloseIcon from '@material-ui/icons/Close';
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import StudentService from "./Locality/Service/studentService";
import CursiveMasterService from "./Locality/Service/cursiveMasterService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import TeacherService from "./Locality/Service/teacherService";
import {
  getTeacherAssignedClasses,
  filterSectionsForAssignedClass,
} from "../../utils/teacherAssignments";
import LanguageSoundHeader from "../../components/LanguageSoundHeader";
import TablePagination from "@material-ui/core/TablePagination";
import { DEFAULT_CURSIVES } from "../../utils/languageDefaults";

const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflowX: "auto",
  },
  pageHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: '1.9rem',
    color: '#1a1a1a',
    lineHeight: 1.2,
  },
  pageSubtitle: {
    color: '#555',
    fontSize: '0.9rem',
    marginTop: 2,
  },
  noteBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#e6e6e6',
    border: '1px solid #d6e4ff',
    marginBottom: theme.spacing(2),
  },
  noteIconWrap: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#1a1a1a',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  filtersCard: {
    borderRadius: 14,
    border: '1px solid #d9d9d9',
    boxShadow: 'none',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filtersRow: {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    width: '100%',
  },
  filtersChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    height: 38,
    boxSizing: 'border-box',
    padding: '0 12px',
    borderRadius: 999,
    border: '1px solid #8f8f8f',
    backgroundColor: '#fff',
    cursor: 'pointer',
    fontWeight: 600,
    color: '#1a1a1a',
    userSelect: 'none',
    flexShrink: 0,
  },
  countBadge: {
    backgroundColor: '#fff',
    color: '#1a1a1a',
    border: '1px solid #c4c4c4',
    borderRadius: 12,
    padding: '1px 10px',
    fontSize: '0.72rem',
    fontWeight: 700,
    marginLeft: 8,
  },
  fieldLabel: {
    fontSize: '0.78rem',
    fontWeight: 600,
    color: '#444',
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    minHeight: 18,
    lineHeight: '18px',
  },
  resetBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    color: '#444',
    border: '1px solid #8f8f8f',
    height: 40,
    minWidth: 88,
    padding: '0 16px',
  },
  filterFieldWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 1 220px',
    minWidth: 150,
    maxWidth: 240,
  },
  filterActionsWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 auto',
    justifyContent: 'flex-end',
  },
  tableCard: {
    borderRadius: 14,
    border: '1px solid #d9d9d9',
    boxShadow: 'none',
    overflow: 'hidden',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
  },
  iconBtnOutlined: {
    border: '1px solid #8f8f8f',
    borderRadius: 8,
    padding: 8,
    color: '#444',
  },
  studentAvatar: {
    width: 30,
    height: 30,
    backgroundColor: '#e6e6e6',
    color: '#1a1a1a',
    fontSize: '0.85rem',
  },
  stickyNameHead: {
    position: 'sticky',
    left: 0,
    zIndex: 5,
    backgroundColor: '#efefef',
    color: '#444',
    fontWeight: 700,
    fontSize: '0.8rem',
    borderBottom: '1px solid #d9d9d9',
    borderRight: '1px solid #d9d9d9',
    minWidth: 200,
  },
  stickyNameCell: {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    backgroundColor: '#fff',
    borderRight: '1px solid #d9d9d9',
    minWidth: 200,
  },
  soundHead: {
    backgroundColor: '#efefef',
    color: '#444',
    fontWeight: 700,
    fontSize: '0.8rem',
    borderBottom: '1px solid #d9d9d9',
    textAlign: 'center',
    minWidth: 96,
  },
  cursiveLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 28,
    height: 32,
    padding: '0 8px',
    borderRadius: 6,
    backgroundColor: '#e6e6e6',
    color: '#1a1a1a',
    fontFamily: '"Marck Script", "Segoe Script", "Brush Script MT", cursive',
    fontSize: '1.4rem',
    fontWeight: 400,
    textTransform: 'none',
    lineHeight: 1,
  },
}));

export default function Cursive() {
  const classes = useStyles();
  const userDetails = JSON.parse(localStorage.getItem("userDetail") || "{}");
  const isTeacher = String(userDetails.role || "").toUpperCase() === "TEACHER";
  const [studentList, setStudentList] = useState([]);
  const [cursives, setCursives] = useState([]);
  const [tableHeaders, setTableHeaders] = useState(["Student Name"]);
  const [pg, setPg] = useState(0);
  const [rpg, setRpg] = useState(5);
  const [listClassId, setListClassId] = useState("");
  const [listSectionId, setListSectionId] = useState("");
  const [addClassList, setAddClassList] = useState([]);
  const [listSectionList, setListSectionList] = useState([]);
  const [teacherHasMultipleClasses, setTeacherHasMultipleClasses] = useState(false);
  const [assignedClassList, setAssignedClassList] = useState([]);
  // ---- Redesigned UI state ----
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleChangePage = (event, newPage) => {
    setPg(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRpg(parseInt(event.target.value, 10));
    setPg(0);
  };

  const effectiveClassId = listClassId || userDetails.classId || "";
  const effectiveSectionId = listSectionId || userDetails.sectionId || "";

  const loadListSectionList = (classId) => {
    if (!classId) {
      setListSectionList([]);
      return;
    }
    SectionService.findSectionList({
      schooleId: userDetails.schooleId,
      classId,
    })
      .then((res) => {
        const sections = Array.isArray(res) ? res : [];
        setListSectionList(
          filterSectionsForAssignedClass(assignedClassList, classId, sections)
        );
      })
      .catch(() => setListSectionList([]));
  };

  const classOptions =
    userDetails.role === "TEACHER" && assignedClassList.length
      ? assignedClassList
      : addClassList;
  const classSelectEnabled =
    userDetails.role !== "TEACHER" || classOptions.length > 1;
  const sectionSelectEnabled = Boolean(listClassId);

  const onListClassChange = (e) => {
    const id = e.target.value;
    setListClassId(id);
    setListSectionId("");
    loadListSectionList(id);
  };

  const onListSectionChange = (e) => {
    setListSectionId(e.target.value);
  };

  // Fetch cursives list from API and combine with existing student cursives
  const getCursivesList = () => {
    const body = {
      schooleId: userDetails.schooleId || "",
    };

    CursiveMasterService.findCursiveMasterList(body)
      .then((res) => {
        // Extract unique cursive names from CursiveMaster
        const masterCursiveNames = [...new Set(
          res
            .map(item => item.name)
            .filter(name => name) // Remove empty/null names
        )];
        
        // Get existing cursives from students
        const getExistingStudentCursives = () => {
          const getSpeList = { classId: effectiveClassId };
          if (effectiveSectionId) getSpeList.sectionId = effectiveSectionId;
          return StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
            .then((studentRes) => {
              // Collect all cursive keys from all students
              const allStudentCursives = new Set();
              studentRes.forEach((student) => {
                if (student.cursives && typeof student.cursives === 'object') {
                  Object.keys(student.cursives).forEach(key => {
                    if (key) allStudentCursives.add(key);
                  });
                }
              });
              return Array.from(allStudentCursives);
            })
            .catch((err) => {
              console.error("Error fetching existing student cursives:", err);
              return [];
            });
        };

        // Combine master cursives with existing student cursives
        getExistingStudentCursives().then((existingCursives) => {
          // Merge both arrays and remove duplicates
          const combinedCursives = [...new Set([...masterCursiveNames, ...existingCursives])];
          
          // Sort cursives alphabetically
          combinedCursives.sort();

          const finalCursives = combinedCursives.length ? combinedCursives : DEFAULT_CURSIVES;
          setCursives(finalCursives);
          // Update table headers dynamically
          setTableHeaders(["Student Name", ...finalCursives]);
        });
      })
      .catch((err) => {
        console.error("Error fetching cursives list:", err);
        // Fallback: try to get existing cursives from students
        const getSpeList = { classId: effectiveClassId };
        if (effectiveSectionId) getSpeList.sectionId = effectiveSectionId;
        StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
          .then((studentRes) => {
            const allStudentCursives = new Set();
            studentRes.forEach((student) => {
              if (student.cursives && typeof student.cursives === 'object') {
                Object.keys(student.cursives).forEach(key => {
                  if (key) allStudentCursives.add(key);
                });
              }
            });
            const existingCursives = Array.from(allStudentCursives).sort();
            const finalCursives = existingCursives.length ? existingCursives : DEFAULT_CURSIVES;
            setCursives(finalCursives);
            setTableHeaders(["Student Name", ...finalCursives]);
          })
          .catch((studentErr) => {
            setCursives(DEFAULT_CURSIVES);
            setTableHeaders(["Student Name", ...DEFAULT_CURSIVES]);
          });
      });
  };

  const getStudentList = () => {
    const getSpeList = { classId: effectiveClassId };
    if (effectiveSectionId) getSpeList.sectionId = effectiveSectionId;
    StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
      .then((res) => {
        const studentDetails = res.map((student) => {
          // Ensure each student has a cursives object; initialize if missing
          const cursivesObj = student.cursives || {};
          cursives.forEach((cursive) => {
            if (!(cursive in cursivesObj)) {
              cursivesObj[cursive] = "";
            }
          });
          return {
            _id: student._id,
            studentName: `${student.firstName} ${student.lastName}`,
            cursives: cursivesObj,
          };
        });
        setStudentList(studentDetails);
      })
      .catch((err) => {
        console.error("Error fetching student list:", err);
      });
  };

  const handleProgressChange = (student, cursiveKey, progressKey) => {
    const cursivesObj = { ...student.cursives };
    cursives.forEach((cursive) => {
      if (!(cursive in cursivesObj)) {
        cursivesObj[cursive] = "";
      }
    });
    cursivesObj[cursiveKey] = progressKey || "";

    // Update the student's cursive locally
    const updatedStudent = {
      ...student,
      cursives: cursivesObj,
    };

    // Update the student list state immediately for better UX
    const updatedList = studentList.map((s) =>
      s._id === student._id ? updatedStudent : s
    );
    setStudentList(updatedList);

    // Call API to update the student
    StudentService.updateLanguageProgress(student._id, { cursives: cursivesObj })
      .then((res) => {
        // Don't refetch immediately - keep the local state
        // The state is already updated above, so no need to refetch
        console.log("Student cursive updated successfully");
      })
      .catch((err) => {
        console.error(err.response?.data?.message || "Error updating student");
        // On error, revert the local state by refetching
        getStudentList();
      });
  };

  useEffect(() => {
    if (!userDetails.schooleId) return;
    if (userDetails.role === "TEACHER" && userDetails.teacherId) {
      TeacherService.getTeacherById(userDetails.teacherId)
        .then((teacher) => {
          const assigned = getTeacherAssignedClasses(teacher);
          setAssignedClassList(assigned);
          setTeacherHasMultipleClasses(assigned.length > 1);
          const primaryAssigned = assigned.find(
            (cls) => String(cls.className || "").trim().toLowerCase() === "primary"
          );
          const defaultClassId =
            primaryAssigned?._id || userDetails.classId || assigned[0]?._id || "";
          const defaultSectionId =
            defaultClassId === String(userDetails.classId || "")
              ? (userDetails.sectionId || "")
              : "";
          setListClassId(defaultClassId);
          setListSectionId(defaultSectionId);
          if (defaultClassId) {
            SectionService.findSectionList({
              schooleId: userDetails.schooleId,
              classId: defaultClassId,
            })
              .then((secRes) => {
                setListSectionList(
                  filterSectionsForAssignedClass(
                    assigned,
                    defaultClassId,
                    Array.isArray(secRes) ? secRes : []
                  )
                );
              })
              .catch(() => setListSectionList([]));
          }
        })
        .catch(() => {
          setTeacherHasMultipleClasses(false);
          setAssignedClassList([]);
        });
      return;
    }
    AddClassService.getAllAddClass(userDetails.schooleId)
      .then((res) => setAddClassList(Array.isArray(res) ? res : []))
      .catch(() => setAddClassList([]));
    setTeacherHasMultipleClasses(true);
  }, []);

  useEffect(() => {
    if (listClassId) {
      loadListSectionList(listClassId);
    }
  }, [listClassId, assignedClassList]);

  useEffect(() => {
    if (userDetails.schooleId && effectiveClassId) {
      getCursivesList();
    }
  }, [effectiveClassId, effectiveSectionId]);

  useEffect(() => {
    // Load students whenever the class/section changes, even if no cursive
    // columns exist yet (e.g. schools without cursive master records).
    if (userDetails.schooleId && effectiveClassId) {
      getStudentList();
    }
    return () => {
      setStudentList([]);
    };
  }, [cursives, effectiveClassId, effectiveSectionId]);

  const filteredStudents = studentList.filter((s) =>
    (s.studentName || "").toLowerCase().includes(searchTerm.toLowerCase())
  );
  const activeFilterCount = [listClassId, listSectionId].filter(Boolean).length;
  const handleResetFilters = () => {
    setListClassId("");
    setListSectionId("");
    setSearchTerm("");
    setPg(0);
  };

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=Marck+Script&display=swap";
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <>
      {/* Page header */}
      <Box className={classes.pageHeader}>
        <Box>
          <Typography className={classes.pageTitle}>Cursives</Typography>
          <Typography className={classes.pageSubtitle}>
            Track each student's cursive writing progress using P, WA, WI, and M.
          </Typography>
        </Box>
      </Box>


      <Card className={classes.tableCard} elevation={0}>
        <Box className={classes.toolbar}>
          <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
            <Typography variant="body2" style={{ color: '#444', fontWeight: 600 }}>
              {filteredStudents.length} {filteredStudents.length === 1 ? 'Student' : 'Students'}
            </Typography>
            <Chip size="small" label={`${cursives.length} Cursives`} style={{ backgroundColor: '#e6e6e6', color: '#1a1a1a', fontWeight: 600 }} />
          </Box>
          <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
            <TextField
              size="small"
              variant="outlined"
              placeholder="Search by student name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ minWidth: 240 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" style={{ color: '#8a8a8a' }} />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="outlined"
              startIcon={<FilterListIcon fontSize="small" />}
              onClick={() => setFiltersOpen((o) => !o)}
              aria-pressed={filtersOpen}
              style={filtersOpen ? { backgroundColor: '#e6e6e6' } : undefined}
            >
              Filters
              {activeFilterCount > 0 && <span className={classes.countBadge}>{activeFilterCount}</span>}
            </Button>
            <Tooltip title="Refresh">
              <span>
                <IconButton
                  className={classes.iconBtnOutlined}
                  onClick={() => getCursivesList()}
                  disabled={!effectiveClassId}
                >
                  <RefreshIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </Box>

        <Box display="flex" alignItems="stretch" flexWrap="wrap">
        <Box flex="1 1 520px" minWidth={0}>
        <TableContainer component={Paper} elevation={0} className={classes.tableOverflow} style={{ maxHeight: 540 }}>
          <Table stickyHeader className="mb-0">
            <TableHead>
              <TableRow>
                <TableCell className={classes.stickyNameHead}>Student Name</TableCell>
                {cursives.map((key) => (
                  <TableCell key={key} className={classes.soundHead}>
                    <LanguageSoundHeader
                      code={key}
                      isTeacher={isTeacher}
                      className={classes.cursiveLabel}
                    />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredStudents.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={cursives.length + 1} align="center" style={{ padding: 36, color: '#8a8a8a' }}>
                    {effectiveClassId ? 'No students found.' : 'Select a class to load students.'}
                  </TableCell>
                </TableRow>
              ) : (
                filteredStudents
                  .slice(pg * rpg, pg * rpg + rpg)
                  .map((student) => (
                    <TableRow key={student._id} hover>
                      <TableCell className={classes.stickyNameCell}>
                        <Box display="flex" alignItems="center" gridGap={10}>
                          <Avatar className={classes.studentAvatar}>
                            {(student.studentName || '?').charAt(0).toUpperCase()}
                          </Avatar>
                          <span style={{ fontWeight: 600, color: '#1a1a1a' }}>{student.studentName}</span>
                        </Box>
                      </TableCell>
                      {cursives.map((key) => (
                        <TableCell key={key} align="center" style={{ padding: '4px 4px', minWidth: 96 }}>
                          <ProgressKeyButtons
                            value={student.cursives[key]}
                            onChange={(progressKey) => handleProgressChange(student, key, progressKey)}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          rowsPerPageOptions={[5, 50, 100, 500, 1000]}
          count={filteredStudents.length}
          page={pg}
          onPageChange={handleChangePage}
          rowsPerPage={rpg}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        </Box>
                {filtersOpen && (
                    <FilterPanel onReset={handleResetFilters}>
                    <FilterSection title="Class" icon={<SchoolIcon style={{ fontSize: 16 }} />}>
                <FormControl fullWidth variant="outlined" size="small" disabled={!classSelectEnabled}>
                  <Select displayEmpty value={listClassId} onChange={onListClassChange}>
                    <MenuItem value=""><em>All Classes</em></MenuItem>
                    {classOptions.map(({ _id, className }) => (
                      <MenuItem key={_id} value={_id}>{className}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                    </FilterSection>
                    <FilterSection title="Section" icon={<PersonIcon style={{ fontSize: 16 }} />}>
                <FormControl fullWidth variant="outlined" size="small" disabled={!sectionSelectEnabled}>
                  <Select displayEmpty value={listSectionId} onChange={onListSectionChange}>
                    <MenuItem value=""><em>All Sections</em></MenuItem>
                    {listSectionList.map(({ _id, sectionName }) => (
                      <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                    </FilterSection>
                    </FilterPanel>
                )}
        </Box>
      </Card>
    </>
  );
}

